import React from "react";
import "./button.css";
import PropTypes from "prop-types";
const Button = ({ onClick, text, customClass, disable }) => {
  return (
    <div className={`text-center ${text.toString().toLowerCase()} ${customClass}`}>
      <button type="button" className="button" onClick={onClick} >
        {text}
      </button>
    </div>
  );
};
Button.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  disable: PropTypes.boolean
};
export default Button;
